(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ordinia-entrega"] && !Shopify.designMode) return;
  try {
    (function () {
    // Día de la semana y mes abreviados en el idioma de la página (data-lang); en español, como antes.
    var DOW = ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'];
    var MON = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sept', 'oct', 'nov', 'dic'];
    function setLang(lang) {
      if (!lang || /^es/i.test(lang) || !window.Intl) return;
      try {
        var w = new Intl.DateTimeFormat(lang, { weekday: 'short' }), m = new Intl.DateTimeFormat(lang, { month: 'short' });
        DOW = DOW.map(function (_, i) { return w.format(new Date(2026, 0, 4 + i)); });
        MON = MON.map(function (_, i) { return m.format(new Date(2026, i, 1)); });
      } catch (e) {}
    }
    function iso(d) { return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0'); }
    function addWorkdays(from, n, holidays) {
      var d = new Date(from.getFullYear(), from.getMonth(), from.getDate());
      while (n > 0) {
        d.setDate(d.getDate() + 1);
        var wd = d.getDay();
        if (wd !== 0 && wd !== 6 && holidays.indexOf(iso(d)) === -1) n--;
      }
      return d;
    }
    function fmt(d) { return DOW[d.getDay()] + ' ' + d.getDate(); }
    function range(a, b) {
      if (a.getMonth() === b.getMonth()) return fmt(a) + '–' + b.getDate() + ' ' + MON[b.getMonth()];
      return fmt(a) + ' ' + MON[a.getMonth()] + ' – ' + fmt(b) + ' ' + MON[b.getMonth()];
    }
    function madridToday() {
      try {
        var p = new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Madrid', year: 'numeric', month: '2-digit', day: '2-digit' }).format(new Date()).split('-');
        return new Date(+p[0], +p[1] - 1, +p[2]);
      } catch (e) { return new Date(); }
    }
    function init(root) {
      (root || document).querySelectorAll('[data-ord-entrega]:not(.is-ready)').forEach(function (el) {
        setLang(el.getAttribute('data-lang'));
        var n = function (k) { return parseInt(el.getAttribute('data-' + k), 10) || 0; };
        var hol = (el.getAttribute('data-holidays') || '').split(/[\s,]+/).filter(Boolean);
        var today = madridToday();
        var out1 = addWorkdays(today, Math.max(1, n('prep-min')), hol);
        var out2 = addWorkdays(today, Math.max(1, n('prep-max')), hol);
        var in1 = addWorkdays(today, n('prep-min') + n('ship-min'), hol);
        var in2 = addWorkdays(today, n('prep-max') + n('ship-max'), hol);
        el.querySelector('[data-ord-ent="sale"]').textContent = range(out1, out2);
        el.querySelector('[data-ord-ent="llega"]').textContent = range(in1, in2);
        el.querySelector('.ord-ent__steps').hidden = false;
        el.classList.add('is-ready');
        if ('IntersectionObserver' in window) {
          var io = new IntersectionObserver(function (es) {
            if (es[0].isIntersecting) { el.classList.add('is-in'); io.disconnect(); }
          }, { threshold: 0.4 });
          io.observe(el);
        } else el.classList.add('is-in');
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
    document.addEventListener('shopify:block:select', function (e) { init(e.target.parentNode); });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ordinia-pack"] && !Shopify.designMode) return;
  try {
    (function () {
    // Cambia la cantidad del formulario de compra de la misma sección (componente de cantidad de Horizon).
    document.addEventListener('change', function (e) {
      var r = e.target;
      if (!r.matches || !r.matches('[data-ord-pack] input[type="radio"]')) return;
      var scope = r.closest('.shopify-section') || document;
      var q = scope.querySelector('form[data-type="add-to-cart-form"] input[name="quantity"]') || scope.querySelector('input[name="quantity"]');
      if (!q) return;
      q.value = r.value;
      ['input', 'change', 'blur'].forEach(function (t) { q.dispatchEvent(new Event(t, { bubbles: true })); });
    });
    // Si se cambia la cantidad a mano, el pack marcado sigue a la cantidad (o ninguno si no es 1 ni 2).
    // Los botones +/− de Horizon no lanzan «change»: se sincroniza tras el clic.
    document.addEventListener('change', function (e) {
      if (e.target.matches && e.target.matches('input[name="quantity"]')) sync(e.target);
    });
    document.addEventListener('click', function (e) {
      var c = e.target.closest && e.target.closest('quantity-selector-component');
      if (!c) return;
      var q = c.querySelector('input[name="quantity"]');
      if (q) setTimeout(function () { sync(q); }, 0);
    });
    function sync(q) {
      var scope = q.closest('.shopify-section') || document;
      var packs = scope.querySelectorAll('[data-ord-pack] input[type="radio"]');
      if (!packs.length) return;
      var n = Math.max(1, parseInt(q.value, 10) || 1);
      packs.forEach(function (r) { r.checked = r.value === String(n); });
      // Total del botón («Añadir a la bolsa · 22,99 €»): cada pareja lleva la 2.ª unidad al −20 % (el pack solo sale en EUR).
      scope.querySelectorAll('.ord-atc-price').forEach(function (s) {
        if (!s.dataset.ordUnit) s.dataset.ordUnit = s.textContent.replace(/[^\d,]/g, '').replace(',', '.');
        var unit = parseFloat(s.dataset.ordUnit);
        if (!unit) return;
        var total = unit * n - 0.2 * unit * Math.floor(n / 2);
        s.textContent = new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' }).format(Math.round(total * 100) / 100);
      });
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
